<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardBody>
          <AppForm 
            :key="appFormKey"
            :vo-name="isEdit ? 'ProductCategoryGetVo' : 'ProductCategoryAddVo'"
            :data="tmpProductCategory" 
            @changed="onFormChange"
          />
        </CCardBody>
        <CCardFooter>
          <LoadingStateButton
            @click="onAddOrUpdateProductCategory"
            :text="i18nMessage.Apply"
            color="primary"
            :loading="updateProductCategoryLoading"
          />
          <template v-if="isEdit">
            &nbsp;
            <CButton color="secondary" @click="showDeleteModal = true">{{i18nMessage.Delete}}</CButton>
          </template>
          &nbsp;
          <CButton color="secondary" @click="goBack">{{i18nMessage.Back}}</CButton>
        </CCardFooter>
      </CCard>
    </CCol>
    <CModal
      :show.sync="showDeleteModal"
      :centered="true"
      color="default"
    >
      {{i18nMessage.PleaseInputTextToConfirmDelete}} <b>{{productCategory.name}}</b>
      <br/><br/>
      <CInput
          :placeholder="i18nMessage.PleaseInputText"
          v-model="deleteConfirmText"
        />
      <template #header>
        <span class="modal-title">{{i18nMessage.Delete}}？</span>
        <CButtonClose @click="showDeleteModal = false" class="text-dark"/>
      </template>
      <template #footer>
        <LoadingStateButton
          :disabled="deleteConfirmText !== productCategory.name"
          @click="onDeleteProductCategory"
          :text="i18nMessage.Apply"
          color="danger"
          :loading="deleteProductCategoryLoading"
        />
        <CButton @click="showDeleteModal = false" color="secondary">{{i18nMessage.Cancel}}</CButton>
      </template>
    </CModal>
  </CRow>
</template>

<script>
import { mapState, mapActions, mapMutations, } from 'vuex'
import { generateGUID } from '../../util'
import AppForm from '../../components/AppForm'
import LoadingStateButton from '../../components/LoadingStateButton'

export default {
  name: 'ProductCategory',
  components: {
    AppForm,
    LoadingStateButton,
  },
  data () {
    return {
      deleteConfirmText: null,
      showDeleteModal: false,
      isEdit: this.$route.params.id && this.$route.params.id.length > 0,
      tmpProductCategory: {},
      updateProductCategoryLoading: false,
      deleteProductCategoryLoading: false,
      appFormKey: generateGUID(),
    }
  },
  computed: {
    ...mapState({
      i18nMessage: state => state.i18nMessage,
      productCategory: state => state.product.productCategory,
    }),
  },
  methods: {
    ...mapActions({
      getProductCategory: 'product/getProductCategory',
      updateProductCategory: 'product/updateProductCategory',
      addProductCategory: 'product/addProductCategory',
      deleteProductCategory: 'product/deleteProductCategory',
    }),
    ...mapMutations({
      setProductCategory: 'product/setProductCategory',
    }),
    goBack() {
      this.$router.push({path: '/product-category'})
    },
    onFormChange (data) {
      this.tmpProductCategory = {...data}
    },
    onAddOrUpdateProductCategory () {
      if (this.tmpProductCategory.id) {
        this.updateProductCategoryLoading = true
        this.updateProductCategory(this.tmpProductCategory)
          .then(() => {
            this.updateProductCategoryLoading = false
            this.appFormKey = generateGUID()
            this.goBack()
          }, () => {
            this.updateProductCategoryLoading = false
          })
      } else {
        this.updateProductCategoryLoading = true
        this.addProductCategory(this.tmpProductCategory)
          .then(() => {
            this.updateProductCategoryLoading = false
            this.appFormKey = generateGUID()
            this.goBack()
          }, () => {
            this.updateProductCategoryLoading = false
          })
      }
    },
    onDeleteProductCategory () {
      this.deleteProductCategoryLoading = true
      this.deleteProductCategory(this.productCategory.id)
          .then(() => {
            this.deleteProductCategoryLoading = false
            this.appFormKey = generateGUID()
            this.goBack()
          }, () => {
            this.deleteProductCategoryLoading = false
            this.showDeleteModal = false
          })
    }
  },
  mounted() {
    if (this.isEdit) {
      this.getProductCategory(this.$route.params.id).then(() => {
        this.tmpProductCategory = this.productCategory
      })
    }
  },
  destroyed() {
    this.setProductCategory({})
  }
}
</script>
